import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { createConnector, InferConnectedProps } from '../../redux/createConnector'
import { isAuthenticated } from '../../redux/profile/selectors'
import AuthLayout, { IProps } from './AuthLayout'

const selector = createStructuredSelector({
  isAuthenticated,
})
const actions = {}
const connector = connect(selector, actions)
export type PropsFromRedux = InferConnectedProps<typeof connector, typeof actions>
export default createConnector<typeof connector, IProps, PropsFromRedux>(connector, AuthLayout)
